/* global $ */
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import superagent from 'superagent'

import {
    config,
    auth,
} from 'website-core'

import index from './pages/index.vue'
import overview from './pages/overview.vue'
import user from './pages/user.vue'
import _export from './pages/export.vue'
import ip from './pages/ip.vue'
import setting from './pages/setting.vue'
import billing from './pages/billing.vue'
import signin from './pages/signin.vue'

const routes = [{
        path: '/',
        component: index,
        children: [{
                path: '',
                component: overview,
            },
            {
                path: '/facebook',
            },
            {
                path: '/google',
            },
            {
                path: '/user',
                component: user,
            },
            {
                path: '/export',
                component: _export,
            },
            {
                path: '/ip',
                component: ip,
            },
            {
                path: '/setting',
                component: setting,
            },
            {
                path: '/billing',
                component: billing,
            },
        ]
    },
    {
        path: '/sign-in',
        component: signin,
    },
    // 404 redirects to home
    {
        path: "*",
        redirect: '/',
    }
]

const router = new Router({
    mode: 'history',
    routes,
})

export default router

router.beforeEach(async (to, from, next) => {
    $('#navbar').collapse('hide')



    switch (to.path) {
        case '/facebook':
            auth.saveSession('facebook')
            next('/')
            return

        case '/google':
            auth.saveSession('google')
            next('/')
            return

        case '/sign-in': // sign-in skip auth    
            next()
            return

        default:
            break;
    }

    // the rest paths need to verify auth
    // must init auth before
    await auth.init()
    checkLogin(to, from, next)
})

async function checkLogin(to, from, next) {
    const ok = await auth.checkAuthStatus()
    if (!ok) {
        next('/sign-in')
        return
    }

    // check customer subscription
    const res = await checkSub()
    if (!res.exist) {
        swal({
            title: 'You must be signed up to access this page',
            text: 'Wanna Sign up?',
            icon: 'warning',
            buttons: true,
        }).then(ok => {
            if (ok) {
                window.location = config.url
                return
            }

            next(false)
            return
        })

        return
    }

    if (!res.active && to.fullPath != '/billing') {
        next('/billing')
        return
    }

    // continue
    next()
}

async function checkSub() {
    try {
        const res = await superagent
            .get(config.url_api + '/customer/exist')
            .query(auth.getAuthQs())
            .ok(res => res.status <= 500)

        switch (res.status) {
            case 200:
                return {
                    exist: true,
                    active: true,
                }

            case 423:
                return {
                    exist: true,
                    active: false,
                }

            default:
                auth.removeSession()
                return {
                    exist: false,
                    active: false,
                }
        }
    } catch (err) {
        auth.removeSession()
        return {
            exist: false,
            active: false,
        }
    }
}